import { Tab, Tabs } from "@material-ui/core";
import { TabContext, TabPanel } from "@material-ui/lab";
import React from "react";
import { FileViewer } from "../EnrollmentVerificationDetailPage/FileViewer";
import { ReportingAccountEnrollmentVerifications } from "../ReportingAccountEnrollmentDetailPage/ReportingAccountEnrollmentVerifications";
import { ChimeEnrollmentDetailView } from "./ChimeEnrollmentDetailView";
import BankAccounts from "../../components/BankAccounts";
import PmsTransactionsPage from "../PmsTransactionsPage";

export default function ChimeDetailsView({
  enrollmentId,
  selectedFile,
  setSelectedFile,
  selectedFileIndex,
  setSelectedFileIndex,
  files,
  setFiles,
  tab,
  setTab,
  customerId,
}) {
  const tabs = [
    {
      title: "Documents",
      component: (
        <FileViewer
          enrollmentId={enrollmentId}
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          selectedFileIndex={selectedFileIndex}
          setSelectedFileIndex={setSelectedFileIndex}
          files={files}
          setFiles={setFiles}
        />
      ),
    },
    {
      title: "Enrollment",
      component: <ChimeEnrollmentDetailView enrollmentId={enrollmentId} />,
    },
    {
      title: "Verifications",
      component: <ReportingAccountEnrollmentVerifications enrollmentId={enrollmentId} />,
    },
    {
      title: "Bank Accounts",
      component: <BankAccounts customerId={customerId} />,
    },
    {
      title: "Transactions",
      component: <PmsTransactionsPage customerId={customerId} defaultPmsOnly={true} />,
    },
  ];
  return (
    <TabContext value={tab}>
      <Tabs value={tab} onChange={(e, value) => setTab(value)}>
        {tabs.map((tab, index) => (
          <Tab key={tab.title} label={tab.title} value={index} />
        ))}
      </Tabs>

      {tabs.map((tab, index) => (
        <TabPanel key={tab.title} value={index}>
          {tab.component}
        </TabPanel>
      ))}
    </TabContext>
  );
}